import React from 'react';
import { PageTitle } from '../components/texts/PageTitle';
import ParallaxDiv from '../components/ParallaxDiv';

const AboutMe = () => {
    const introMsg = "Hi! My name is Selisa Lyn Johnson. I live in Columbus, Georgia with two of my grandchildren, Christian and Javonte, and I spend most of my time raising them. I started writing when I was a student at Delaware Elementary school in Evansville, Indiana, and I had several of my books published as Selisa Johnson. During my senior year of high school at Central, I became pregnant with my son, Adrian, and after spending several months at a Home for Unwed Mothers, I decided against putting him up for adoption, and I began my life as a single mother. I had a publishing dispute with my Publishing Company, and they blocked me from publishing any new works, and the fact that i couldn't get anything else published sent me into a heavy depression. I had been having severe up and down moods and hazy thoughts for years and at age nineteen, I was diagnosed as being Bi-Polar, and that ended my everyday life, and I had fears that I would never be in control again and that I would be rejected from society and I worried that I had nothing worthwhile to offer anybody. I attempted suicide and survived and found out that I was pregnant with my daughter, Latricia. Over the years, I've been hospitalized too numerous of times to count and my children had to struggle with a lot. I thought that condition was the worst thing that could happen to me, but at nine years old Latricia was diagnosed with Lupus and I had to put my own selfish thoughts behind me and just concentrate on keeping her well. Adrian went to live with my brother, Randy Kimbrew, when he was eleven and he stayed with his uncle's family until he graduated from college at Columbus State University and he brought his first house. Latricia and I came to live with Adrian in 2005 and I've been there ever since then. Latricia got married and moved to Houston, Texas in 2014 and Adrian has been enjoying a successful career in Las Vegas, Nevada for the past several years. Besides taking care of my grandchildren, I like to watch shows like Maury, Judge Mathis and Jerry Springer, and I enjoy listening to my collection of Classic Rock CDs. Most of my time is spent writing and I hope to get all my manuscripts published someday. Thanks to Adrian editing and uploading my books on Amazon that seems possible!";
    return (
        <ParallaxDiv backgroundChoice={1}>
            <div style={styles.parallaxContentStyle}>
                <PageTitle>About Me</PageTitle>
                <div className="container" style={styles.containerStyle}>
                    <div className="jumbotron my-4">
                        <div className="row">
                            <span className="anchor" id="aboutme"></span> 
                            <div className="col-md-4">
                                <img style={styles.authorImageStyle} src={require('../assets/misc/slj_author.jpg')} alt='' width='225px' />
                                <br /><br />
                                <h6><a href="http://amazon.com/author/selisalynjohnson" target="_blank" rel="noopener noreferrer">Amazon Author Central</a ></h6>
                                <h6><a href="mailto:selisa@selisalynjohnsonbooks.com" target="_blank" rel="noopener noreferrer">selisa@selisalynjohnsonbooks.com</a ></h6>
                            </div>
                            <div className="col-md-8">
                                <h1 style={styles.nameTextStyle}>Selisa Lyn Johnson</h1>
                                <p style={styles.descriptionStyle}>{introMsg}
                                    
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ParallaxDiv>
    );
};

export default AboutMe;

const styles = {
    authorImageStyle: {
        height: 300,
        width: 300,
        borderRadius: '50%',
        marginRight: 30
    },
    nameTextStyle: {
        color: '#03b0e8',
        textAlign: 'left'
    },
    containerStyle: {
        marginTop: 100
    },
    descriptionStyle: {
        textAlign: 'left'
    },
    parallaxContentStyle: {
        paddingTop: 50, 
        paddingBottom: 200
    }
}